<template>
  <v-container fluid>
    <v-row class="ma-3" wrap>
      <!-- Descrição -->
      <v-col cols="12">
        <v-text-field
          v-model="statusCurso.descricao"
          ref="descricao"
          label="Descrição"
          placeholder="Digite a descrição do status de curso"
          dense
          outlined
          data-vv-as="descrição"
          persistent-hint
          :hint="errors.first('res_status_curso.descricao')"
          :error="
            errors.collect('res_status_curso.descricao').length ? true : false
          "
          v-validate="'required|min:3|max:150'"
          data-vv-scope="res_status_curso"
          data-vv-validate-on="change"
          id="descricao"
          name="descricao"
        >
        </v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "StatusCursosForm",
  inject: ["$validator"],
  computed: {
    statusCurso: {
      get() {
        return this.$store.getters["resStatusCursos/getStatusCurso"];
      },
      set(value) {
        this.$store.dispatch("resStatusCursos/setStatusCurso", value);
      },
    },
  },
};
</script>

<style></style>
